import React, { Component } from "react";
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import AdjudicatorComments from "./AdjudicatorComments";
import MDMediaList from "components/Admin/FestivalMusicDirector/MDMediaList";
import { Grid, Row, Col, OverlayTrigger, Popover, Tooltip} from "react-bootstrap";

class DashboardPage extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { musicDirector } = this.props;
		console.log('musicDirector', musicDirector);
		return(
			<section className="first_section">
        		<div className="container">

        			<div className="row">
        				<div className="col-md-12">
        					<Tabs>
								<TabList className="mainTabs">
									<Tab>
										Adjudicator Comments
									</Tab>
									<Tab>
										Festival Performance
									</Tab>
								</TabList>
								<TabPanel>
									<AdjudicatorComments />
								</TabPanel>
								<TabPanel>
									<Row>
						        		<Col md={12}>
						        			<p className="ml-xlg" >You can upload any audio or video recordings you have of your performance here.</p>
						        		</Col>
		        					</Row>
									<MDMediaList mdId={musicDirector ? musicDirector.id : 'mdid'} />
								</TabPanel>
							</Tabs>
        				</div>
        			</div>
					
        		</div>
        	</section>
		);
	}
}

const mapDispatchToProps = dispatch => {
	return ({
		// exampleFunctionCall: () => { dispatch(exampleAction.exampleFunction()) },//example function
	});
};

function mapStateToProps(state) {
	const {musicDirector } = state.musicDirectorReducer;
	

	return {
		musicDirector
	};
}


const Dashboard = connect(mapStateToProps, mapDispatchToProps)(DashboardPage);
export default Dashboard;


// WEBPACK FOOTER //
// ./src/components/FrontEnd/Dashboard.jsx